import photo1 from"./Images/male-portrait-1156365_1280.jpg"
import photo2 from'./Images/businessman-1247947_1280.jpg'
import photo3 from'./Images/pexels-christina-morillo-1181391.jpg'
export const AboutSlider =[
    {
        id:1,
        company:"Barichu Farmers Cooperative Society Limited",
        rank:"Secretary General",
        image:photo1,
        body:"For more information visit my Resume under title Referee"
    },
    {
        id:2,
        company:"Elly Computer Institute",
        rank:"C.E.O",
        image:photo2,
     body:"For more information visit my Resume under title Referee"
    },
     {
        id:3,
        company:"Freelancer.com",
        rank:"Secretary General",
        image:photo3,
        body:"For more information visit my Resume under title Referee"
    },
    {
        id:4,
        company:"Upwork.com",
        rank:"Secretary General",
        image:photo1,
        body:"For more information visit my Resume under title Referee"
    },
    {
        id:5,
        company:"Online Evedences Limited",
        rank:"Secretary General",
        image:photo2,
        body:"For more information visit my Resume under title Referee"
    },
]
